
























// Core
import {Component, Prop, Vue} from 'vue-property-decorator'
import {IDocumentKit} from "@store/documents/Interface";


@Component({
  name: 'WorkComplectAside',
  components: {
    'v-no-content': () => import('@/components/NoContent.vue'),
  },
})

export default class WorkComplectAside extends Vue {
  @Prop(Array) readonly documentKits!: IDocumentKit[]
  @Prop(Object) readonly activeComplect!: IDocumentKit
  @Prop({type: Boolean, default: true}) readonly loading!: boolean

  private openComplect(complect) {
    this.$emit('changeActiveComplect', complect)
  }

}
